import axios from "axios";
import { domain, ticketBaseURL } from "../config/api";

export type HealthCheck = () => Promise<boolean>;

export const checkServerHealth = async () => {
    try {
        const response = await axios.get(`${domain}/health`, {
            timeout: 60000
        });

        return response.status === 200;
    } catch (error) {
        console.log("Health check failed:", error);
        return false;
    }
}

export const checkTicketServerHealth = async () => {
    try {
        const response = await axios.get(`${ticketBaseURL}mycdir/health`, {
            timeout: 60000
        });

        return response.status === 200;
    } catch (error) {
        console.log("Health check failed:", error);
        return false;
    }
}